module.exports = __webpack_public_path__ + "static/img/error.bd594c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/error.png
// module id = 0/ar
// module chunks = 0